module.exports = __webpack_public_path__ + "za.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/za.svg
// module id = 1150
// module chunks = 0